import * as apiSW from 'api/errorMessage/GetErrorMessageStartingWithV1';
import * as apiPostSearch from 'api/errorMessage/PostErrorMessageSearchV1';
import ErrorMessage from 'classes/StandingData/ErrorMessage/Search/ErrorMessage';
import { ISelectItem } from 'interfaces/ISelectItem';

export default class ErrorMessageList {
	public all: ErrorMessage[] = [];
	public filtered: ISelectItem[] = [];
	public totalCount: number = 0;

	public async search(searchTerm: string, showOnlyDeleted: boolean): Promise<void> {
		const errorMessages = await apiSW.callApi(searchTerm, showOnlyDeleted);
		errorMessages.hasValue() && this.mapFromApiSW(errorMessages.get());
	}

	public async callApi(input: apiPostSearch.Request) {
		return await apiPostSearch.callApi(input);
	}

	public mapFromApi(input: apiPostSearch.ResponseData): void {
		this.totalCount = input.totalCount;
		this.all = [];
		for (const i of input.data) {
			const errorMessage: ErrorMessage = new ErrorMessage(i);
			this.all.push(errorMessage);
		}
	}

	public mapFromApiSW(input: apiSW.ResponseErrorMessage[]): void {
		this.filtered = [];
		for (const i of input) {
			this.filtered.push({
				id: i.id,
				name: i.errorKey,
			});
		}
	}
}
